import { render, staticRenderFns } from "./ListBuildings.vue?vue&type=template&id=0a80a9c6&scoped=true&"
import script from "./ListBuildings.vue?vue&type=script&lang=js&"
export * from "./ListBuildings.vue?vue&type=script&lang=js&"
import style0 from "./ListBuildings.vue?vue&type=style&index=0&id=0a80a9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80a9c6",
  null
  
)

export default component.exports